import React, { useState, useRef, useEffect } from "react";
import { ReactComponent as Onboarding } from "../assets/Grapic_Bg.svg";
import { FORGET_PASS_URL, RESET_PASS_URL, VERIFY_OTP, VERIFY_RESET_OTP } from "../../../utils/constants";
import { Password } from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";

const ForgetPassword = () => {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState(Array(6).fill(""));

  const [errorMessage, setErrorMessage] = useState(null);
  const [otpError, setOtpError] = useState(false);
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [sessionToken, setSessionToken] = useState(null);
  const inputsRef = useRef([]);

  const location = useLocation();
  const authType = location.state?.authType;

  const correctOTP = "123456"; // Mock OTP

  const handleChange = (e, index) => {
    const value = e.target.value;
    console.log("value", value);
    if (!/^[0-9]?$/.test(value)) return;

    const newCode = [...otp];
    newCode[index] = value;
    setOtp(newCode);

    if (value && index < 5) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      e.preventDefault();
      const newCode = [...otp];
      if (otp[index]) {
        newCode[index] = "";
      } else if (index > 0) {
        newCode[index - 1] = "";
        inputsRef.current[index - 1]?.focus();
      }
      setOtp(newCode);
    }
  };

  const validatePassword = () => {
    const hasUpper = /[A-Z]/.test(newPassword);
    const hasLower = /[a-z]/.test(newPassword);
    const hasNumber = /\d/.test(newPassword);
    const hasSpecial = /[!@#$%^&*]/.test(newPassword);
    return newPassword.length >= 8 && hasUpper && hasLower && hasNumber && hasSpecial;
  };
  const resendOtp = async () => {
    try {
      const response = await fetch(FORGET_PASS_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email: email.trim() }),
      });
    } catch (error) {
      console.log("Error resending OTP:", error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (step === 1) {
      // Proceed to OTP input
      if (!email || !email.trim()) {
        setErrorMessage("Email cannot be empty");
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email.trim())) {
        setErrorMessage("Please enter a valid email address");
        return;
      }

      try {
        const response = await fetch(FORGET_PASS_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: email.trim() }),
        });

        const data = await response.json();

        if (!data.success) {
          setErrorMessage(data.message);
          return;
        }
      } catch (error) {}
      setErrorMessage(null);
      setStep(2);
    } else if (step === 2) {
      const enteredOtp = otp.join("");

      if (enteredOtp.length < 6) {
        setOtpError("OTP must be 6 digits long.");
        return;
      } else {
        setOtpError(null);
      }

      try {
        const response = await fetch(VERIFY_RESET_OTP, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ otp: enteredOtp, email: email.trim() }),
        });

        const data = await response.json();

        if (!data?.success) {
          setOtpError(data?.message || "Invalid OTP. Please try again.");
          return;
        }

        if (data?.success) {
          setSessionToken(data?.data?.sessionToken);

          setStep(3);
        }
      } catch (error) {}
    } else if (step === 3) {
      if (newPassword !== confirmPassword) {
        setErrorMessage("Passwords do not match.");
        return;
      }

      // Password strength regex
      const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;

      if (!passwordRegex.test(newPassword)) {
        setErrorMessage(
          "Password must be at least 8 characters long, contain uppercase and lowercase letters, a number, and a special character."
        );
        return;
      } else {
        setErrorMessage(null);
      }

      try {
        const response = await fetch(RESET_PASS_URL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ email: email.trim(), new_password: newPassword, session_token: sessionToken }),
        });
        const data = await response.json();

        if (!data?.success) {
          setErrorMessage(data?.message || "Failed to reset password. Please try again.");
          return;
        }

        if (data?.success) {
          navigate("/", { state: { authType: "forget-password" } });
        }
      } catch (error) {
        console.error("Error:", error);
        setErrorMessage("An error occurred. Please try again.");
      }
    }
  };

  const renderOtpInputs = () => (
    <div className="flex justify-between gap-2 mt-2">
      {otp.map((digit, index) => (
        <input
          key={index}
          type="text"
          maxLength={1}
          value={digit}
          ref={(el) => (inputsRef.current[index] = el)}
          onChange={(e) => handleChange(e, index)}
          onKeyDown={(e) => handleKeyDown(e, index)}
          className="w-10 h-11 border border-gray-300 text-center text-lg rounded"
        />
      ))}
    </div>
  );

  const renderStepContent = () => {
    if (step === 1) {
      return (
        <>
          <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
          <input
            type="text"
            placeholder="dummy@gmail.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#0D426D] text-sm"
          />
        </>
      );
    }

    if (step === 2) {
      return (
        <>
          <label className="block text-sm font-medium text-gray-700 ">Email</label>
          <input
            type="email"
            value={email}
            disabled
            className="w-full px-3 py-2 bg-gray-100 border border-gray-300 rounded-md text-sm"
          />
          <p className="mt-2 text-sm text-gray-700">
            Please enter your 6 digit code sent to your registered email address{" "}
            <span className="font-medium text-black">{email}</span>.
          </p>
          {renderOtpInputs()}
          <p className="mt-2 text-sm text-red-500 cursor-pointer text-right" onClick={resendOtp}>
            Resend OTP
          </p>
          {otpError && <p className="text-sm text-red-500 mt-2">{otpError}</p>}
        </>
      );
    }

    if (step === 3) {
      return (
        <>
          <label className="block text-sm font-medium text-gray-700 mb-1">New password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
          />
          <ul className="mt-2 space-y-1 text-sm text-green-600">
            <li className={newPassword.length >= 8 ? "text-green-600" : "text-gray-400"}>
              ✅ Enter a Minimum 8 characters
            </li>
            <li className={/[A-Z]/.test(newPassword) && /[a-z]/.test(newPassword) ? "text-green-600" : "text-gray-400"}>
              ✅ Use uppercase and lowercase letters
            </li>
            <li
              className={/\d/.test(newPassword) && /[!@#$%^&*]/.test(newPassword) ? "text-green-600" : "text-gray-400"}
            >
              ✅ Enter at least 1 number and a special character
            </li>
          </ul>

          <label className="block text-sm font-medium text-gray-700 mt-4 mb-1">Confirm new password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
          />
          {}
        </>
      );
    }
  };

  return (
    <main className="relative min-h-screen flex items-center justify-center bg-[#0D426D] p-4 font-Inter">
      {/* Background Onboarding (positioned absolutely) */}
      <div className="absolute inset-0 z-0">
        <Onboarding className="w-full h-full object-cover" />
      </div>

      {/* Foreground Section */}
      <section className="relative z-10 w-full max-w-md bg-[#F3F4F6] rounded-md p-6 sm:p-8 shadow-md">
        <h2 className="text-center text-xl sm:text-2xl font-semibold text-[#0D426D] mb-6">Forget Password</h2>

        <form onSubmit={handleSubmit} className="space-y-5">
          {renderStepContent()}
          {errorMessage && <p className="text-F16136 text-xs">{errorMessage}</p>}
          <button
            type="submit"
            className="w-full bg-[#0D426D] hover:bg-[#093559] text-white py-2 rounded-md font-medium text-sm"
          >
            Submit
          </button>
        </form>

        {step === 1 && (
          <div className="mt-6 border-t border-dashed w-[70%] border-gray-300 pt-4 text-center text-sm mx-auto">
            Don’t have an account?{" "}
            <a href="#" className="text-[#0D426D] font-medium hover:underline">
              Sign up now.
            </a>
          </div>
        )}
      </section>
    </main>
  );
};

export default ForgetPassword;
